import React from 'react';

let MAX_LEN = 20;
export const shorten = (str, max = MAX_LEN) => {
	if (str.length <= max) return <p>{str}</p>;
	else {
		return <p>{str.slice(0, max + 1)}...</p>;
	}
};
